import { lenis } from './lenis';

const anchorLinks = document.querySelectorAll('.anchor-links li > a, .anchor');

function getVirtualScrollY(target, headerHeight = 0) {
  const frames = [...document.querySelectorAll('.frame')];
  const frame = target.closest('.frame');
  if (!frame) return 0;

  let y = 0;

  for (const f of frames) {
    if (f === frame) break;
    y += f.scrollHeight;
  }

  const innerOffset =
    target.getBoundingClientRect().top - frame.getBoundingClientRect().top;

  return y + innerOffset - headerHeight * 2;
}

anchorLinks.forEach(link => {
  link.addEventListener('click', e => {
    const href = link.getAttribute('href');
    if (!href || !href.startsWith('#') || href === '#') return;

    e.preventDefault();

    const header = document.querySelector('.header');
    const headerHeight = header?.offsetHeight || 0;

    if (href === '#hero') {
      lenis?.scrollTo(0, { duration: 1 });
      return;
    }

    const target = document.querySelector(href);

    if (target && lenis) {
      const y = getVirtualScrollY(target, headerHeight);

      lenis.scrollTo(y, {
        duration: 1,
        easing: t => 1 - Math.pow(1 - t, 5),
      });
    } else {
      const scrollOffset = headerHeight;
      const pathParts = window.location.pathname.split('/');
      const langPrefix =
        pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';
      window.location.href = `${langPrefix}/${href}?offset=${scrollOffset}`;
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const fullHash = window.location.hash;
  if (!fullHash || !lenis) return;

  const [hashOnly, queryString] = fullHash.split('?');
  const target = document.querySelector(hashOnly);
  if (!target) return;

  const header = document.querySelector('.header');
  const headerHeight = header?.offsetHeight || 0;

  const params = new URLSearchParams(queryString || '');
  const offset = parseInt(params.get('offset') || headerHeight, 10);

  requestAnimationFrame(() => {
    lenis.scrollTo(getVirtualScrollY(target, offset), {
      duration: 1,
      easing: t => 1 - Math.pow(1 - t, 5),
    });
  });

  // const pathParts = window.location.pathname.split('/');
  // const langPrefix =
  //   pathParts[1] && pathParts[1].length === 2 ? `/${pathParts[1]}` : '';

  // history.replaceState(null, '', langPrefix + '/');
});

// <ul class="anchor-links">
//   <li class="menu-item">
//     <a href="#"></a>
//   </li>
// </ul>
